
<template>
  <div class="modal-body-user-info">
    <div class="description">
      {{ modalAction == actionTypes.createUser ? 'Add a new user' : 'Edit a user' }} by entering the information below.
    </div>
    <div class="name row">
      <div class="first-name">
        <div class="text">First name:</div>
        <div>
          <input class="input" v-validate="'required'" type="text" name="firstName" placeholder="First Name" v-model="userInfo.firstName">
        </div>
      </div>
      <div class="last-name">
        <div class="text">Last name:</div>
        <div >
          <input class="input" v-validate="'required'" type="text" name="lastName" placeholder="Last Name" v-model="userInfo.lastName">
        </div>
      </div>
    </div>
    <div class="email">
      <div class="text">Email address:</div>
      <div>
        <input class="input" v-validate="'required|email'" name="email" type="text" placeholder="E.g. hannah_welch@gmail.com" v-model="userInfo.email">
      </div>
    </div>
    <div class="phone">
      <div class="text">Phone:</div>
      <div>
        <input class="input" v-the-mask="'+1(###)-###-####'" v-validate="'required'" name="phone" type="text" placeholder="+1(###)-###-####" v-model="userInfo.phoneNumber">
      </div>
    </div>
    <div class="row role-client">
      <div class="role">
        <div class="text">Role:</div>
        <div >
          <!-- <input class="input" type="text"> -->
          <Multiselect v-model="role" label="text" :options="listUserRole" track-by="name" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Choose a role" class="input" :openDirection="'below'" @select="selectRole"></Multiselect>
        </div>
      </div>
      <div class="client" v-if="showClientList">
        <div class="text">Client:</div>
        <div>
          <multiselect v-model="clientAccount"
                       :options="clientList"
                       placeholder="Choose the client for this client"
                       label="clientName"
                       :openDirection="'below'"
                       :multiple="false"
                       :close-on-select="true"
                       :hide-selected="true"
                       track-by="id"
                       :allow-empty="true"
                       :show-labels="false"
                       @select="selectClient"
                       :max-height="174"
                       class="input">
          </multiselect>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import consts from '../../_consts';
import {mapGetters, mapActions} from 'vuex';
import { mask } from 'vue-the-mask';
export default {
  name: 'body-modal-user-info',
  props: {
    userInfo: {
      type: Object,
      default: {
        id: -1,
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        clientAccount: {
        },
        role: {}
      }
    },
    modalAction: {
      type: String,
      default: ''
    },
    disableBtnRight: {
      type: Boolean,
      default: false
    },
    modalDataValid: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Multiselect
  },
  data () {
    return {
      listUserRole: [
        {
          name: 'eventManager',
          text: 'Event Manager',
          role: 'EVENT_MANAGER'
        },
        {
          name: 'accountManager',
          text: 'Account Manager',
          role: 'ACCOUNT_MANAGER'
        },
        {
          name: 'staff',
          text: 'Staff',
          role: 'STAFF'
        }
      ],
      showClientList: false,
      role: {},
      clientAccount: {},
      actionTypes: consts.modalAction
    }
  },
  directives: { 'the-mask': mask },
  computed: {
    ...mapGetters({
      clientList: 'GETTERS_CLIENT_LIST'
    })
  },
  methods: {
    selectRole (selectedOption) {
      this.showClientList = selectedOption.role.toLowerCase() === consts.USER_ROLE.client.toLowerCase();
      this.userInfo.role = selectedOption.role;
      this.userInfo.clientId = selectedOption.role.toLowerCase() !== consts.USER_ROLE.client.toLowerCase() ? 0 : '';
      // this.validateData();
    },
    selectClient (selectedOption) {
      this.userInfo.client = selectedOption;
      this.userInfo.clientId = selectedOption.id;
      this.userInfo.clientName = selectedOption.clientName;
      // this.validateData();
    },
    validateData: async function () {
      await this.$validator.validate().then(result => {
        if (!result) {
          this.userInfo.modalDataValid = false;
          let errors = this.errors;
          if (errors.count() === 1 && errors.firstRule('email')) {
            this.showModalInfo(consts.modalAction.emailMustBeAValid);
          } else {
            this.showModalInfo(consts.modalAction.someFieldsBlank);
          }
        } else {
          if (this.userInfo.role === '' || this.userInfo.clientId === '') {
            this.showModalInfo(consts.modalAction.someFieldsBlank);
            this.userInfo.modalDataValid = false;
          } else {
            this.userInfo.modalDataValid = true;
          }
        }
      });
    },
    showModalInfo (modalType) {
      let modalData = {
        action: modalType,
        data: null
      };
      this.$modal.show('modalInfo', modalData);
    },
    ...mapActions({})
  },
  created () {
    let userRole = this.userInfo.role === consts.USER_ROLE.clientManager ? consts.USER_ROLE.client : this.userInfo.role;
    if (localStorage.getItem(consts.LOCAL_STORE.role) === consts.USER_ROLE.admin) {
      let adminObj = {
        name: 'admin',
        text: 'Admin',
        role: 'ADMIN'
      };
      this.listUserRole.push(adminObj);
    }
    this.listUserRole.forEach(element => {
      if (element.role.toLowerCase() === userRole.toLowerCase()) {
        this.role = element;
        if (userRole.toLowerCase() === consts.USER_ROLE.client.toLowerCase()) {
          this.showClientList = true;
          this.clientAccount = this.userInfo.client;
        }
      }
    });
    // this.$on('validateDataOnUserModal', this.validateData())
    this.userInfo.modalDataValid = true;
    if (this.modalAction === this.actionTypes.createUser) {
      this.userInfo.client = '';
    }
  }
}
</script>

<style lang="less">
.modal-body-user-info{
  color: #231F20;
  font-family: "Open Sans";
  font-size: 14px;
  .description{
    line-height: 14px;
  }
  .input{
    height: 38px;
    border: 1px solid #d9d9d9;
    border-radius: 3px;
    padding-left: 12px;
  }
  .name{
    margin: 30px 0 0 0;
    .last-name{
      margin-left: 40px;
      .text{}
      .input{
        width: 275px;
      }
    }
    .first-name{
      .text{}
      .input{
        width: 275px;
      }
    }
  }
  .email{
    margin: 30px 0 0 0;
    .text{}
    .input{
      width: 590px;
    }
  }
  .phone{
    margin: 30px 0 0 0;
    .text{}
    .input{
      width: 590px;
    }
  }
  .role-client{
    margin: 30px 0 0 0;
    height: 150px;
    .role{
      .text{}
      .input{
        padding: 0;
        width: 275px;
      }
      .multiselect{
        min-height: 38px;
      }
      .multiselect__tags{
        border: none;
        min-height: 38px;
      }
      .multiselect__content-wrapper{
        background-color: none;
        background: none;
        .multiselect__element:last-child{
          border-bottom: none;
        }
      }
    }
    .client{
      margin-left: 40px;
      .text{}
      .input{
        padding: 0;
        width: 275px;
      }
      .multiselect{
        min-height: 38px;
      }
      .multiselect__tags{
        border: none;
        min-height: 38px;
      }
      .multiselect__content-wrapper{
        background-color: none;
        background: none;
        .multiselect__element:last-child{
          border-bottom: none;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// UserInfo.vue?af4a7494